import React, { PureComponent } from 'react';
import CardWithRadio, { ICardWithRadio } from '@jg/card-with-radio';

interface Props<T>
  extends Pick<ICardWithRadio, 'id' | 'name' | 'photo' | 'text' | 'checked'> {
  onChangeFunc: (id: T) => void;
  value: T;
}

class CardWithRadioWrapper<T> extends PureComponent<Props<T>> {
  onChange = () => {
    const { value, onChangeFunc } = this.props;
    onChangeFunc(value);
  };

  render() {
    const { id, photo, text, checked } = this.props;
    return (
      <CardWithRadio
        id={id}
        name={name}
        photo={photo}
        text={text}
        onChange={this.onChange}
        checked={checked}
      />
    );
  }
}

export default CardWithRadioWrapper;
